// extracted by mini-css-extract-plugin
module.exports = {"layout":"_0EfCRgxFAwX-STuDVizk5g=="};